export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        // text: 'NEW'
      }
    },

    {
      title: true,
      name: 'Network',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },

    {
      name: 'Devices',
      url: '/devices',
      icon: 'fa fa-wifi'
    },


    {
      name: 'Configs',
      url: '/configs',
      icon: 'icon-note'
    },


    {
      title: true,
      name: 'Administration',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },


    // {
    //     name: 'DemoData',
    //     url: '/extras/vuetable',
    //     icon: 'icon-energy'
    //   },

    {
      name: 'Users',
      url: '/users',
      icon: 'icon-user'
    },

    {
      name: 'Account',
      url: '/accounts',
      icon: 'fa fa-institution'
    },







    // {
    //   name: 'API Docs (TBD)',
    //   url: 'http://readynetsolutions.com',
    //   icon: 'icon-cloud-download',
    //   class: 'mt-auto',
    //   variant: 'success',
    //   attributes: { target: '_blank', rel: 'noopener' }
    // },
    // {
    //   name: 'ReadyNet',
    //   url: 'http://readynetsolutions.com',
    //   icon: 'icon-layers',
    //   variant: 'outline-primary',
    //   attributes: { target: '_blank', rel: 'noopener' }
    // },
  ]
}
